import { useReadContract, useWriteContract } from "wagmi";
import presale_ABI from "../contracts/presale_abi.json";

const presale_address = "0xe420ff531abecdc1d4feb4aa0c825a31bda6c84c";

export const useGetCurrentPresaleRound = () => {
  const { data, isLoading, isError, queryKey } = useReadContract({
    address: presale_address,
    abi: presale_ABI,
    functionName: "currentRound",
    args: [],
  });

  return { data, isLoading, isError, queryKey };
};

export const useGetTokenSoldByRound = (roundId) => {
  let currentRound = "tokensSoldRound1";
  if (roundId === 1) {
    currentRound = "tokensSoldRound1";
  } else if (roundId === 2) {
    currentRound = "tokensSoldRound2";
  } else {
    currentRound = "tokensSoldRound3";
  }
  const { data, isLoading, isError, queryKey } = useReadContract({
    address: presale_address,
    abi: presale_ABI,
    functionName: currentRound,
    args: [],
  });

  return { data, isLoading, isError, queryKey };
};

export const useBuyToken = (amount) => {
  const { writeContract } = useWriteContract();
  writeContract({
    address: presale_address,
    abi: presale_ABI,
    functionName: "buyTokens",
    args: [amount],
  });
};
